exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "@-webkit-keyframes _2MPWvKAZXK8XMSKLEzL7Iw {\n  to { -webkit-transform: rotate(1turn); transform: rotate(1turn); }\n}\n\n@keyframes _2MPWvKAZXK8XMSKLEzL7Iw {\n  to { -webkit-transform: rotate(1turn); transform: rotate(1turn); }\n}\n\n._2pn_LfEO6y77qlB4Urh5kF {\n  position: relative;\n  display: inline-block;\n\n  -webkit-animation: _2MPWvKAZXK8XMSKLEzL7Iw 850ms infinite;\n\n          animation: _2MPWvKAZXK8XMSKLEzL7Iw 850ms infinite;\n  -webkit-animation-timing-function: linear;\n          animation-timing-function: linear;\n}\n._2BmY-k4NYd75qfZyepYIgq {\n  width: 20px;\n  height: 20px;\n}\n._2BmY-k4NYd75qfZyepYIgq svg {\n    width: 20px;\n    height: 20px;\n}\n._2DUlALwO_IJOknrXzUkh6c {\n  width: 16px;\n  height: 16px;\n}\n._2DUlALwO_IJOknrXzUkh6c svg {\n    width: 16px;\n    height: 16px;\n}\n._1szd8SxpPtnUg2-v8AWS8A {\n  width: 60px;\n  height: 60px;\n}\n._31tc4ariJREWBSBLcCZ0xh {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-align: center;\n        align-items: center;\n    -ms-flex-pack: center;\n        justify-content: center;\n}\n", ""]);

// exports
exports.locals = {
	"progress": "_2pn_LfEO6y77qlB4Urh5kF",
	"spin": "_2MPWvKAZXK8XMSKLEzL7Iw",
	"small": "_2BmY-k4NYd75qfZyepYIgq _2pn_LfEO6y77qlB4Urh5kF",
	"xsmall": "_2DUlALwO_IJOknrXzUkh6c _2pn_LfEO6y77qlB4Urh5kF",
	"large": "_1szd8SxpPtnUg2-v8AWS8A _2pn_LfEO6y77qlB4Urh5kF",
	"loaderWrapper": "_31tc4ariJREWBSBLcCZ0xh"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":{"localIdentName":"[name]__[local]___[hash:base64:5]"}}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null,null]}!./src/legacy/components/Loading/Loading.css
// module id = 2975
// module chunks = 23